import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/earning-report.svg";
var EarningReportOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  EarningReportOutline_default as default
};
